import { makeVar } from '@apollo/client';

/** @type {import('@apollo/client').ReactiveVar<'connecting' | 'connected' | 'disconnected'>} */
const wsConnectionStatusVar = makeVar('disconnected');

export default wsConnectionStatusVar;
